<template>
  <form-request
    :action="src"
    method="post"
    v-slot="{ submit }"
  >
    <confirm-danger
      title="Restore Package"
      button="Restore"
      :show="show"
      @confirm="restore(submit)"
      @close="$emit('close')"
    >
      Are you sure you want to restore this package?
    </confirm-danger>
  </form-request>
</template>

<script>
import ConfirmDanger from '@/Components/Modals/ConfirmDanger'
import FormRequest from '@/Components/Forms/FormRequest'
import Error from '@/Components/Forms/Error'

export default {
  components: { ConfirmDanger, FormRequest, Error },
  emits: ['close'],
  props: {
    /**
     * If true we display the form
     */
    show: {
      type: Boolean,
      default: false
    },

    /**
     * The route to send the delete request to.
     */
    src: {
      type: String,
      default: null
    }
  },

  methods: {
    /**
     * Submits delete request to the server
     * @param submit a function (passed by form-request) that submits the form
     */
    restore(submit) {
      this.$emit('close')
      submit()
    }
  }
}
</script>
